(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["trip-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oh-trip-countdown')) {
  customElements.define('oh-trip-countdown', class extends HTMLElement {
    connectedCallback() {
      this.target = Date.parse(this.dataset.start || '');
      if (!Number.isFinite(this.target)) return;
      this.output = this.querySelector('[data-countdown-output]');
      this.template = this.output?.dataset.countdownTemplate || '';
      this.refresh = () => this.update();
      this.update();
      if (!this.hidden) {
        this.timer = setInterval(this.refresh, 60000);
        document.addEventListener('visibilitychange', this.refresh);
      }
    }
    update() {
      const remaining = this.target - Date.now();
      if (remaining <= 0) {
        this.hidden = true;
        this.stop();
        return;
      }
      const days = Math.ceil(remaining / 86400000);
      this.output.textContent = this.template.replace('[count]', String(days));
      this.hidden = false;
    }
    stop() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
    }
    disconnectedCallback() {
      this.stop();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["trip-photo-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('oh-trip-gallery')) {
  customElements.define('oh-trip-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.slides = Array.from(this.querySelectorAll('[data-photo-slide]'));
      if (!this.slides.length) return;
      this.index = 0;
      this.requestId = 0;
      this.dialog = this.querySelector('dialog');
      this.full = this.querySelector('[data-photo-full]');
      this.hero = this.closest('.tp-hero');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      const on = (node, event, handler) => node.addEventListener(event, handler, { signal });
      on(this, 'click', event => {
        const target = event.target.closest('button, [data-photo-slide]');
        if (!target) return;
        if (target.matches('[data-photo-slide]')) {
          if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          if (typeof this.dialog.showModal !== 'function') return;
          event.preventDefault();
          if (performance.now() < (this.suppressClickUntil || 0)) return;
          this.open(target);
        } else if (target.matches('[data-photo-close]')) this.dialog.close();
        else if (target.matches('[data-photo-next]')) this.step(1);
        else if (target.matches('[data-photo-prev]')) this.step(-1);

      });
      on(this, 'keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        this.step(event.key === 'ArrowRight' ? 1 : -1);
      });
      on(this.dialog, 'close', () => {
        document.documentElement.classList.remove('oh-photo-viewer-open');
        this.opener?.focus({ preventScroll: true });
        this.schedule();
      });
      on(this.hero, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      });
      on(this.hero, 'pointerleave', () => { this.hovered = false; this.schedule(); });
      on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      on(this, 'focusout', () => queueMicrotask(() => {
        this.focused = this.contains(document.activeElement);
        this.schedule();
      }));
      on(document, 'visibilitychange', () => this.schedule());
      on(this.motion, 'change', () => {
        this.paused = this.motion.matches;
        this.schedule();
      });
      for (const surface of [this.querySelector('.oh-photos__slides'), this.querySelector('.oh-photos__stage')]) {
        let start;
        on(surface, 'pointerdown', event => {
          if (!event.isPrimary || event.button !== 0) return;
          start = { x: event.clientX, y: event.clientY, id: event.pointerId };
        });
        on(surface, 'pointercancel', () => { start = null; });
        on(surface, 'pointerup', event => {
          if (!start || event.pointerId !== start.id) return;
          const dx = event.clientX - start.x;
          const dy = event.clientY - start.y;
          start = null;
          if (Math.abs(dx) < 50 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
          this.suppressClickUntil = performance.now() + 500;
          this.step(dx < 0 ? 1 : -1);
        });
        on(surface, 'dragstart', event => event.preventDefault());
      }
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.schedule();
      }, { threshold: 0.15 });
      this.observer.observe(this.hero);
      this.load((this.index + 1) % this.slides.length);
    }
    load(index) {
      const img = this.slides[index].querySelector('img');
      if (img.dataset.src) {
        img.srcset = img.dataset.srcset;
        img.src = img.dataset.src;
        delete img.dataset.src;
        delete img.dataset.srcset;
      }
      return img;
    }
    async show(index) {
      const next = (index + this.slides.length) % this.slides.length;
      const request = ++this.requestId;
      const img = this.load(next);
      try { await img.decode(); } catch (_) { if (!img.naturalWidth) return; }
      if (request !== this.requestId || !this.isConnected) return;
      this.index = next;
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === next);
        slide.setAttribute('aria-hidden', String(i !== next));
        slide.tabIndex = i === next ? 0 : -1;
      });
      this.querySelectorAll('[data-photo-count]').forEach(el => { el.textContent = `${next + 1} / ${this.slides.length}`; });
      if (this.dialog.open) this.updateFull();
      this.load((next + 1) % this.slides.length);
    }
    step(direction) {
      clearTimeout(this.timer);
      this.show(this.index + direction).finally(() => this.schedule());
    }
    updateFull() {
      const slide = this.slides[this.index];
      this.full.alt = slide.querySelector('img').alt;
      this.full.src = slide.href;
    }
    open(opener) {
      this.opener = opener;
      if (typeof this.dialog.showModal !== 'function') {
        window.location.assign(this.slides[this.index].href);
        return;
      }
      ++this.requestId;
      this.updateFull();
      this.dialog.showModal();
      document.documentElement.classList.add('oh-photo-viewer-open');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || this.slides.length < 2 || this.paused || this.hovered || this.focused || this.dialog.open || !this.visible || document.hidden) return;
      this.timer = setTimeout(async () => {
        await this.show(this.index + 1);
        this.schedule();
      }, 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      ++this.requestId;
      if (this.dialog?.open) {
        this.dialog.close();
        document.documentElement.classList.remove('oh-photo-viewer-open');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
